export default {

  'menu.live': '直播间管理',
  'menu.room': '直播间列表',
  'menu.audit': '直播间审核',
  'menu.gift': '礼物管理',
  'menu.giftItem': '礼物列表',
  'menu.instruction': '直播间公告列表',
  'menu.livePlatform': '直播平台管理',
  'menu.search': '搜索管理',
  'menu.hot': '热门搜索列表',

};
